<template>
  <dialog-reset
    title="变更记录"
    :visible.sync="visible"
    width="1180px"
    top="5vh"
    height="70vh"
    :appendToBody="false"
    :modalShow="false"
    :zoomShow="false"
    @close="$emit('update:visible', false)"

  >
    <div class="change-log" v-loading="loading">
      <div class="record-list">
        <el-table
          :data="records"
          height="240"
          size="mini"
          border
          @row-click="handleRowClick"
          :row-class-name="rowClass"
        >
          <el-table-column type="index" label="#" width="60" />
          <el-table-column prop="changeType" label="变更类型" width="120">
            <template slot-scope="{ row }">
              {{ changeTypeMap[row.changeType] || row.changeType || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="变更时间" min-width="160" />
<!--          <el-table-column prop="leaseName" label="租约名称" min-width="140" />-->
        </el-table>
      </div>
      <div class="record-detail" v-if="currentRecord">
        <div class="detail-title">变更明细</div>
        <el-table :data="fields" border size="small">
          <el-table-column prop="label" label="字段" width="160" />
          <el-table-column label="变更前">
            <template slot-scope="{ row }">
              <span v-if="row.prop !== 'contractAttachment'">{{ formatValue(row.prop, currentBefore[row.prop], currentBefore) }}</span>
              <el-link v-else-if="currentBefore[row.prop]" :href="currentBefore[row.prop]" target="_blank" type="primary" :underline="false">
                <i class="el-icon-document"></i> {{ formatValue(row.prop, currentBefore[row.prop], currentBefore) }}
              </el-link>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="变更后">
            <template slot-scope="{ row }">
              <span v-if="row.prop !== 'contractAttachment'">{{ formatValue(row.prop, currentAfter[row.prop], currentAfter) }}</span>
              <el-link v-else-if="currentAfter[row.prop]" :href="currentAfter[row.prop]" target="_blank" type="primary" :underline="false">
                <i class="el-icon-document"></i> {{ formatValue(row.prop, currentAfter[row.prop], currentAfter) }}
              </el-link>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <span slot="dialog_footer" class="dialog-footer">
      <el-button @click="$emit('update:visible', false)">关闭</el-button>
    </span>
  </dialog-reset>
</template>

<script>
import { changeTypeOptions, YES_NO_DICT, LEASE_STATUS_DICT } from '../const'
import request from '@/router/axios'

export default {
  name: 'ChangeLogDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    records: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeIndex: 0,
      custDict: [], // 货主字典
      // 展示字段与 stockLease 列表保持一致
      fields: [
        { label: '租约编号', prop: 'leaseNo' },
        { label: '租约名称', prop: 'leaseName' },
        { label: '货主名称', prop: 'custName' },
        { label: '租赁总面积（㎡）', prop: 'totalArea' },
        { label: '租约状态', prop: 'leaseStatus' },
        { label: '合同附件', prop: 'contractAttachment' },
        { label: '是否自动续租', prop: 'autoRenew' },
        { label: '提前通知期（天）', prop: 'reminderDays' },
        { label: '提前1个月提醒是否已发送', prop: 'reminderSent' },
        { label: '库位列表', prop: 'list' },
        { label: '备注', prop: 'remark' },
        { label: '创建时间', prop: 'createTime' },
      ],
      changeTypeMap: changeTypeOptions.reduce((acc, cur) => ({ ...acc, [cur.value]: cur.label }), {})
    }
  },
  computed: {
    currentRecord () {
      return this.records && this.records.length ? this.records[this.activeIndex] : null
    },
    currentBefore () {
      if (!this.currentRecord) return {}
      return this.parseData(this.currentRecord.beforeData)
    },
    currentAfter () {
      if (!this.currentRecord) return {}
      return this.parseData(this.currentRecord.afterData)
    }
  },
  watch: {
    records: {
      handler () {
        this.activeIndex = 0
      },
      deep: true
    },
    visible (val) {
      if (!val) {
        this.activeIndex = 0
      } else {
        this.loadCustDict()
      }
    }
  },
  mounted () {
    this.loadCustDict()
  },
  methods: {
    async loadCustDict () {
      try {
        const res = await request({
          url: '/api/produce/blade-dept/select/distinct/select',
          method: 'post',
          data: {}
        })
        if (res.data) {
          this.custDict = res.data || []
        }
      } catch (e) {
        console.error('加载货主字典失败', e)
      }
    },
    handleRowClick (row) {
      const idx = this.records.findIndex(item => item === row)
      this.activeIndex = idx > -1 ? idx : 0
    },
    rowClass ({ rowIndex }) {
      return rowIndex === this.activeIndex ? 'active-row' : ''
    },
    parseData (data) {
      if (!data) return {}
      try {
        const parsed = typeof data === 'string' ? JSON.parse(data) : data
        return parsed || {}
      } catch (e) {
        return {}
      }
    },
    formatValue (prop, value, fullData = {}) {
      if (prop === 'leaseStatus') {
        const hit = LEASE_STATUS_DICT.find(i => i.value === value)
        return hit ? hit.label : (value || '-')
      }
      if (prop === 'autoRenew' || prop === 'reminderSent') {
        const hit = YES_NO_DICT.find(i => i.value === value)
        return hit ? hit.label : (value || '-')
      }
      if (prop === 'custName') {
        // 优先通过货主编码从字典中查找货主名称
        if (fullData.custNo && this.custDict.length) {
          const custNo = fullData.custNo
          const hit = this.custDict.find(item => {
            return item.id === custNo
          })
          if (hit) {
            return hit.deptName || '-'
          }
        }
        // 如果字典中找不到，使用原始值
        return value || '-'
      }
      if (prop === 'contractAttachment') {
        // 合同附件显示文件名或链接文本
        if (!value) return '-'
        try {
          const url = new URL(value)
          return url.pathname.split('/').pop() || value
        } catch (e) {
          return value
        }
      }
      if (prop === 'list') {
        if (!Array.isArray(value) || !value.length) return '-'
        return value.map(v => `${v.stockName || ''}${v.stockName ? ' - ' : ''}${v.locationName || v.locationCode || ''}`).join('；')
      }
      if (value === null || value === undefined || value === '') {
        return '-'
      }
      return value
    }
  }
}
</script>

<style scoped>
.change-log {
  display: flex;
  gap: 12px;
}
.record-list {
  width: 360px;
}
.record-detail {
  flex: 1;
}
.detail-title {
  font-weight: 600;
  margin: 6px 0 8px;
}
:deep(.active-row) {
  background: #f0f9ff;
}
</style>


